import Cookies from "js-cookie";

import Api from "@repo/api";
import { canadaTransport } from "@repo/protobuf/api/canadaRpc";
import { usTransport } from "@repo/protobuf/api/usRpc";
import RestApi, { Get } from "@repo/rest/RestApi";
import Env from "@repo/utils-client/Env";

export default RestApi.create<{
  e2e: {
    emails: {
      "confirmation-token": Get<{ email: string }, { token: string }>;
    };
  };
}>(Env.resolveUrl(Api.origin));

export const appApi = RestApi.create<{
  region: Get<{}, { region: string; country: string }>;
}>(
  `${import.meta.env.MOBILE ? Env.resolveUrl(import.meta.env.WEB_ORIGIN) : ""}/api`
);

const canadaRest = RestApi.create<{
  e2e: {
    emails: {
      "confirmation-token": Get<{ email: string }, { token: string }>;
    };
  };
}>(Env.resolveUrl(Api.origin));

const usRest = RestApi.create<{
  api: {
    v1: {
      "user-lead": Get<Record<string, string>, string | undefined>;
    };
  };
  "e2e-testing": {
    emails: {
      [email: string]: {
        "email-confirmation-url": Get<{}, { emailConfirmationUrl: string }>;
      };
    };
  };
}>(Env.resolveUrl(Api.origin));

export const devRpc =
  import.meta.env.API_ADAPTER === "us"
    ? {
        emailConfirmationToken(email: string) {
          return usRest["e2e-testing"].emails[email]![
            "email-confirmation-url"
          ].GET({}).then(({ emailConfirmationUrl }) => {
            return emailConfirmationUrl.split("/").at(-1)!;
          });
        },
      }
    : {
        emailConfirmationToken(email: string) {
          return canadaRest.e2e.emails["confirmation-token"]
            .GET({ email })
            .then(({ token }) => token);
        },
      };

export const xHeaders = {
  userLead: "X-User-Lead",
};

export const restRpc =
  import.meta.env.API_ADAPTER === "us"
    ? {
        async fetchUserLead() {
          const cookie = Cookies.get(xHeaders.userLead);
          const userLead = await usRest.api.v1["user-lead"].GET(
            Object.fromEntries(new URLSearchParams(window.location.search)),
            { headers: { [xHeaders.userLead]: cookie } }
          );

          if (userLead) Cookies.set(xHeaders.userLead, userLead);

          return userLead;
        },
      }
    : {
        fetchUserLead: () => Promise.resolve(),
      };

// Use this to add headers and other request options to protobuf rpc clients
export const transportEvents =
  import.meta.env.API_ADAPTER === "us"
    ? usTransport.events
    : canadaTransport.events;
